"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdLaravelResources = require("cccisd-laravel-resources");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Resources = function Resources(_ref) {
  var isCourseComplete = _ref.isCourseComplete,
    settings = _ref.settings;
  if (!isCourseComplete && settings.lockedUntilCompletion) {
    return /*#__PURE__*/_react["default"].createElement("div", null, settings.tabName, " may only be accessed after completing the course.");
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ResourceCenter, {
    handle: settings.resourceCenter,
    hideShareButton: true
  }));
};
var _default = Resources;
exports["default"] = _default;